module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"breadcrumbs":{"homepage":"Startside"}},"de":{"version":1,"breadcrumbs":{"homepage":"Startseite"}},"en":{"breadcrumbs":{"homepage":"Homepage"}},"fr":{"breadcrumbs":{"homepage":"Page d\u0027accueil"}},"nl":{"breadcrumbs":{"homepage":"Startpagina"}},"pl":{"breadcrumbs":{"homepage":"Strona główna"}}}')
  delete Component.options._Ctor
}
